/** Superuser tenant impersonation auto-clears after this duration from `impersonationStartedAt` (Phase 6). */
export const IMPERSONATION_TTL_MS = 8 * 60 * 60 * 1000;

export const IMPERSONATION_TTL_HOURS = 8;
